<template>
<section class="profile-friends">
    <loading v-if="loading"></loading>
    <template v-if="!loading">
        <div class="friend-requests" v-if="friendRequests.length">
            <button class="btn btn-danger pull-right" @click="declineAll">{{ t.decline_all }}</button>
            <h1>{{ t.friend_requests }}</h1>
            <div class="profile-friends-list profile-list">
                <user v-for="friend in friendRequests" :user="friend" :key="friend.id">
                    <div slot="buttons" class="buttons two-buttons">
                        <button class="btn btn-success btn-sm" @click="accept(friend)">{{ gt.accept }}</button>
                        <button class="btn btn-danger btn-sm" @click="decline(friend)">{{ gt.decline }}</button>
                    </div>
                </user>
            </div>
        </div>
        <friendsAndFollowing type="friend" @vouch="showVouch" :local-config="localConfig"></friendsAndFollowing>
        <div class="pending-requests" v-if="pendingFriends.length">
            <h1>{{ t.pending_friends }}</h1>
            <div class="profile-friends-list profile-list">
                <user v-for="friend in pendingFriends" :user="friend" :key="friend.id">
                    <div slot="buttons" class="buttons one-button">
                        <button class="btn btn-danger btn-sm" @click="cancel(friend)">{{ gt.cancel }}</button>
                    </div>
                </user>
            </div>
        </div>
        <modal :title="t.title_vouch_for_friend.replace('%username', vouch.user.userName)" v-model="vouch.show" :submit="t.vouch"
            @submit="submitVouch">
            {{ t.notice_vouch_for_friend.replace('%username', vouch.user.userName) }}
            <form @keydown="validate('msg')">
                <loading v-if="vouch.loading"></loading>
                <div v-if="!vouch.loading" :class="['form-group', { 'has-error': form.errors.has('msg') }]">
                    <textarea class="form-control vouch-msg" v-model="form.msg"></textarea>
                    <span class="help-block" v-if="form.errors.has('msg')">{{ form.errors.get('msg') }}</span>
                </div>
            </form>
        </modal>
    </template>
</section>
</template>

<script>
import ajax from 'Site/js/util/ajax.fetch';
import Form from 'Site/js/util/form';
import Loading from 'Site/component/Loading.vue';
import Modal from 'Site/component/Modal.vue';
import User from 'Profile/component/User.vue';
import { mapActions, mapState } from 'vuex';
import FriendsAndFollowing from './FriendsAndFollowing.vue';

export default {
    name: 'ProfileFriends',
    components: {
        FriendsAndFollowing,
        Loading,
        Modal,
        User,
    },
    computed: {
        ...mapState({
            gt: state => state.gt.common
        })
    },
    data() {
        return {
            form: new Form({
                msg: '',
                user: ''
            }, {
                msg: [{ type: 'required' }]
            }),
            friendRequests: [],
            loading: true,
            localConfig: {},
            pendingFriends: [],
            t: {},
            vouch: {
                loading: false,
                show: false,
                user: {}
            }
        };
    },
    methods: {
        ...mapActions(['notify']),
        accept(friend) {
            ajax.update('request', { id: friend.id }).then((response) => {
                this.notify({ msg: response.message });
                this.friendRequests = this.friendRequests.filter(filterFriend => filterFriend !== friend);
            });
        },
        cancel(friend) {
            ajax.delete('request', { id: friend.id, type: 0 }).then((response) => {
                this.notify({ msg: response.message });
                this.pendingFriends = this.pendingFriends.filter(filterFriend => filterFriend !== friend);
            });
        },
        decline(friend) {
            ajax.delete('request', { id: friend.id, type: 1 }).then((response) => {
                this.notify({ msg: response.message });
                this.friendRequests = this.friendRequests.filter(filterFriend => filterFriend !== friend);
            });
        },
        declineAll() {
            ajax.delete('request').then((response) => {
                this.notify({ msg: response.message });
                this.friendRequests = [];
            });
        },
        showVouch(friend) {
            this.vouch.user = friend;
            this.vouch.show = true;
        },
        submitVouch() {
            this.form.user = this.vouch.user.id;
            this.vouch.loading = true;
            const form = this.form.create(this.vouchEndpoint);
            if (form) {
                form.then((response) => {
                    this.notify({ msg: response.message });
                    this.vouch.show = false;
                    this.vouch.loading = false;
                });
            }
        },
        validate(field) {
            this.form.errors.clear(field);
            this.form.validate(field);
        }
    },
    created() {
        const setData = (settings) => {
            settings = JSON.parse(settings);
            this.localConfig = settings;
            this.friendRequests = settings.data.requests;
            this.pendingFriends = settings.data.pendingFriends;
            this.vouchEndpoint = settings.endpoints.vouch;
            this.t = settings.translate;
            this.loading = false;
        };
        if (document.querySelector('#friend-json')) {
            const settings = document.querySelector('#friend-json').textContent;
            if (settings) {
                setData(settings);
            }
        } else {
            ajax.get(window.location.href).then((data) => {
                setData(data);
            });
        }
    }
};

</script>

<style lang="scss">
@import "~Site/scss/variables";
.profile-friends {
    .friend-requests {
        margin-bottom: 10px;
        .profile-result {
            height: 222px;
        }
    }
    .pending-requests {
        margin: 10px 0;
        .profile-result {
            height: 222px;
        }
    }
}
@media (max-width: $screen-sm-max) {
    .profile-friends {
        .friend-requests .profile-result {
            height: 211px;
        }
        .pending-requests .profile-result {
            height: 211px;
        }
    }
}
</style>
